import React, { useMemo } from 'react';
import { Container } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { isMobile } from '../../../core/helpers/isMobile';
import { getGameImages } from '../../../core/helpers/getGameImages';

import { winBarStore } from '../../../store/winBarStore';
import { freeBetStore } from '../../../store/freeBetStore';
import { userInfoStore } from '../../../store/userInfoStore';
import { applicationStore } from '../../../store/applicationStore';

import WinAmountComponent from './win';
import LastWinAmountComponent from './lastWin';
import TotalWinAmountComponent from './totalWin';
import { gameStore } from '../../../store/gameStore';
import WinLineComponent from './winLine';

const WinLastWin = observer(() => {
  const { currentFreeBet } = freeBetStore;
  const { spinResult } = gameStore;
  const { currencySymbol, currencyIcon } = userInfoStore;
  const { canvasTranslationKeys, isShowLicenseMode, isDemo } = applicationStore;
  const {
    showAmountContainerInfo: { isTotalWinContainer, isLastWinContainer, isWinContainer },
    winAmount,
    lastWinAmount,
    totalWinAmount,
  } = winBarStore;

  const { winLineBg, lastWinBg, freeSpinCountBg } = useMemo(() => {
    return getGameImages();
  }, []);

  return (
    <Container name='WinLastWinContainer' x={isMobile() ? 270 : 718} y={isMobile() ? 20 : 662}>
      <WinAmountComponent
        amountValue={winAmount}
        isVisible={isWinContainer && !currentFreeBet}
        backGroundTexture={lastWinBg}
        currencySymbol={isShowLicenseMode && !isDemo ? currencyIcon : currencySymbol}
        canvasTranslationKeys={canvasTranslationKeys}
        y={isMobile() ? 32 : 37}
      />
      <LastWinAmountComponent
        amountValue={lastWinAmount}
        isVisible={isLastWinContainer && !currentFreeBet}
        backGroundTexture={lastWinBg}
        currencySymbol={isShowLicenseMode && !isDemo ? currencyIcon : currencySymbol}
        canvasTranslationKeys={canvasTranslationKeys}
        y={isMobile() ? 32 : 37}
      />
      <TotalWinAmountComponent
        isVisible={currentFreeBet}
        amountValue={totalWinAmount}
        currencySymbol={isShowLicenseMode && !isDemo ? currencyIcon : currencySymbol}
        backGroundTexture={freeSpinCountBg}
        isVisibleTotalAmount={isTotalWinContainer}
        canvasTranslationKeys={canvasTranslationKeys}
        y={isMobile() ? 47 : 44}
      >
        <WinAmountComponent
          y={-15}
          hasBackGround={false}
          amountValue={winAmount}
          isVisible={isWinContainer}
          currencySymbol={isShowLicenseMode && !isDemo ? currencyIcon : currencySymbol}
          canvasTranslationKeys={canvasTranslationKeys}
        />
      </TotalWinAmountComponent>
      {spinResult?.additional?.wins && (
        <WinLineComponent
          allWinLines={spinResult.additional.wins}
          amountValue={winAmount}
          isVisible={(isWinContainer && !currentFreeBet) || currentFreeBet}
          backGroundTexture={winLineBg}
          currencySymbol={isShowLicenseMode && !isDemo ? currencyIcon : currencySymbol}
          canvasTranslationKeys={canvasTranslationKeys}
        />
      )}
    </Container>
  );
});

export default WinLastWin;
